import { useEffect } from "react";
import { useSim } from "../lib/store";

// Advances the time-of-day slowly when Auto-Cycle is on (sun sweep + day/night transition).
export function LightingController() {
  useEffect(() => {
    const id = setInterval(() => {
      const st = useSim.getState();
      if (!st.autoCycle) return;
      let t = st.timeOfDay + 0.06;
      if (t > 24) t = 6;
      st.setTimeOfDay(t);
    }, 100);
    return () => clearInterval(id);
  }, []);
  return null;
}
